/*
 * @Author: Han
 * @Date: 2021-11-24 13:25:40
 * @LastEditors: Han
 * @LastEditTime: 2022-03-21 13:32:21
 * @FilePath: \yooacs\console\src\http\api.js
 */
import * as login from './moudules/login'
import * as menu from './moudules/menu'
import * as workforceManagement from './moudules/workforceManagement'
import * as informationMaintenance from './moudules/informationMaintenance'
import * as shiftSetting from './moudules/shiftSetting'
import * as homePage from './moudules/homePage'
import * as notificationManagement from './moudules/notificationManagement'
import * as courseManagement from './moudules/courseManagement'
import * as authorityManagement from './moudules/authorityManagement'
import * as orderManagement from './moudules/orderManagement'
import * as evaluationManagement from './moudules/curriculumEvaluationManagement'
import * as certificationAudit from './moudules/certificationAudit'




/* 
 * 将所有接口统一起来便于维护
 * 如果项目很大可以将 url 独立成文件，接口分成不同的模块
 */
// 默认全部导出
export default {
  login,
  menu,
  workforceManagement,
  informationMaintenance,
  shiftSetting,
  homePage,
  courseManagement,
  notificationManagement,
  authorityManagement,
  orderManagement,
  evaluationManagement,
  certificationAudit
}



// WEBPACK FOOTER //
// ./src/http/api.js